import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Grid } from "semantic-ui-react";
import { RoomboxDetails } from "../";
import styles from "./styles.less";

const imageSrcWithCrop = src => `${src}?w=450&h=300&mode=crop`;
const imageOrigSrcWithCrop = src => `${src}?w=600&h=400&mode=crop`;

export class RoomBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandbleState: this.props.allExpandbleState
    };
  }

  componentDidMount() {
    const { getAnalyticsPlaceHolders } = this.props;
    this.props.onLoad();
    getAnalyticsPlaceHolders && getAnalyticsPlaceHolders();
  }

  componentDidUpdate(prevProps) {
    const { allExpandbleState } = this.props;
    if (prevProps.allExpandbleState != allExpandbleState) {
      this.setState({ expandbleState: allExpandbleState });
    }
  }

  componentWillUnmount() {
    const { clearAnalyticsPlaceHolders } = this.props;
    clearAnalyticsPlaceHolders && clearAnalyticsPlaceHolders();
  }

  toggleExpandbleState = () => {
    let currenctExpandbleState = this.state.expandbleState;
    this.setState({ expandbleState: !currenctExpandbleState });
  };

  renderRoomboxDetails = (images, room) => {
    const {
      onRoomDetailsClick,
      onRateSelection,
      onRateReadMore,
      onShowMoreAmenities,
      selectedRateIdOfCurrentPax,
      isRtl,
      lang,
      titles,
      checkinDate,
      checkoutDate,
      selectedOption,
      currentPaxCombination,
      isMobileView,
      hotelData,
      isClubActive,
      clubUserLoggedIn,
      showAvailability,
      lowAvailabilityCount,
      onClubPricesInterestingClick,
      showFullHeaderDetails,
      isClubPricesInterested,
      ratesGroupRef,
      roomBoxDetailsHeaderRef,
      onShowRatesClick,
      onShowContactUsForm,
      ShowCancellationPolicy,
      contactUsSubmitingStatus,
      submitContactUsForm,
      contactUsFormRef,
      isDealMode,
      showSimpleClubLoginModal,
      onShowRoomGalleryPopUp,
      clubPercentageDiscount,
      isIE,
      ratesGroupVisible,
      selectedPaxId,
      switchImagesAutomatically,
      displayPriceWithoutTaxes,
      routing,
      openSearchboxWin
    } = this.props;

    return (
      <RoomboxDetails
        key={room.id + selectedPaxId}
        titles={titles}
        isRtl={isRtl}
        lang={lang}
        hotelData={hotelData}
        isMobileView={isMobileView}
        room={room}
        images={images}
        checkinDate={checkinDate}
        checkoutDate={checkoutDate}
        selectedOption={selectedOption}
        currentPaxCombination={currentPaxCombination}
        selectedRateIdOfCurrentPax={selectedRateIdOfCurrentPax}
        showAvailability={showAvailability}
        lowAvailabilityCount={lowAvailabilityCount}
        onShowImagesClick={this.onShowRoomImagesClick}
        onRateSelection={onRateSelection}
        onRateReadMore={onRateReadMore}
        onShowMoreAmenities={onShowMoreAmenities}
        onRoomDetailsClick={onRoomDetailsClick}
        onClubPricesInterestingClick={onClubPricesInterestingClick}
        clubUserLoggedIn={clubUserLoggedIn}
        ratesGroupRef={ratesGroupRef}
        contactUsFormRef={contactUsFormRef}
        roomBoxDetailsHeaderRef={roomBoxDetailsHeaderRef}
        isClubActive={isClubActive}
        isClubPricesInterested={isClubPricesInterested}
        showFullHeaderDetails={showFullHeaderDetails}
        showSimpleClubLoginModal={showSimpleClubLoginModal}
        onShowRatesClick={onShowRatesClick}
        onShowContactUsForm={onShowContactUsForm}
        ShowCancellationPolicy={ShowCancellationPolicy}
        contactUsSubmitingStatus={contactUsSubmitingStatus}
        submitContactUsForm={submitContactUsForm}
        isDealMode={isDealMode}
        isIE={isIE}
        ratesGroupVisible={ratesGroupVisible}
        onShowRoomGalleryPopUp={onShowRoomGalleryPopUp}
        clubPercentageDiscount={clubPercentageDiscount}
        switchImagesAutomatically={switchImagesAutomatically}
        selectedPaxId={selectedPaxId}
        toggleExpandbleResultsView={this.toggleExpandbleState}
        expandbleState={this.state.expandbleState}
        displayPriceWithoutTaxes={displayPriceWithoutTaxes}
        routing={routing}
        openSearchboxWin={openSearchboxWin}
      />
    );
  };

  mapRoomImages = room => {
    let images = [];
    if (room) {
      if (room.images && room.images.length > 0) {
        images = room.images.map(image => ({
          original: image && imageOrigSrcWithCrop(image),
          originalTitle: room.name,
          thumbnail: image && imageSrcWithCrop(image),
          description: room.description,
          price: room.lowestPrice,
          currency: room.currency
        }));
      } else {
        images = [
          {
            original:
              room.defaultImageUrl &&
              imageOrigSrcWithCrop(room.defaultImageUrl),
            originalTitle: room.name,
            thumbnail:
              room.defaultImageUrl && imageSrcWithCrop(room.defaultImageUrl),
            description: room.description,
            price: room.lowestPrice,
            currency: room.currency
          }
        ];
      }
    }
    return images;
  };

  render() {
    const { room, isRtl } = this.props;
    const { expandbleState } = this.state;
    //TODO: this should be handled in a more elegant way.
    let images = this.mapRoomImages(room);
    return (
      <Grid
        key={room && room.id}
        columns={1}
        stackable
        className={cx(styles.roombox, { [styles.rtl]: isRtl })}
        textAlign={isRtl ? "right" : "left"}
      >
        <Grid.Column
          className={cx(styles.galleryWrapper, styles.openView, {
            [styles.closedView]: !expandbleState
          })}
          width={16}
        >
          {this.renderRoomboxDetails(images, room)}
        </Grid.Column>
      </Grid>
    );
  }
}

RoomBox.defaultProps = {};

RoomBox.propTypes = {
  isRtl: PropTypes.bool,
  titles: PropTypes.object,
  lang: PropTypes.string,
  hotelData: PropTypes.object,
  checkinDate: PropTypes.string,
  checkoutDate: PropTypes.string,
  selectedOption: PropTypes.object,
  contactUsSubmitingStatus: PropTypes.object,
  submitContactUsForm: PropTypes.func,
  currentPaxCombination: PropTypes.object,
  isMobileView: PropTypes.bool,
  selectedRateIdOfCurrentPax: PropTypes.string,
  room: PropTypes.object,
  showAvailability: PropTypes.bool,
  lowAvailabilityCount: PropTypes.number,
  isClubActive: PropTypes.bool,
  showFullHeaderDetails: PropTypes.bool,
  isClubPricesInterested: PropTypes.bool,
  clubUserLoggedIn: PropTypes.bool,
  onRateSelection: PropTypes.func,
  onRateReadMore: PropTypes.func,
  onShowMoreAmenities: PropTypes.func,
  onRoomDetailsClick: PropTypes.func,
  ratesGroupRef: PropTypes.func,
  contactUsFormRef: PropTypes.func,
  roomBoxDetailsHeaderRef: PropTypes.func,
  onClubPricesInterestingClick: PropTypes.func,
  showSimpleClubLoginModal: PropTypes.func,
  onShowRatesClick: PropTypes.func,
  onShowContactUsForm: PropTypes.func,
  ShowCancellationPolicy: PropTypes.bool,
  isDealMode: PropTypes.bool,
  isIE: PropTypes.bool,
  onShowRoomGalleryPopUp: PropTypes.func,
  ratesGroupVisible: PropTypes.bool,
  clubPercentageDiscount: PropTypes.number,
  switchImagesAutomatically: PropTypes.bool,
  selectedPaxId: PropTypes.number,
  onLoad: PropTypes.func,
  clearAnalyticsPlaceHolders: PropTypes.func,
  getAnalyticsPlaceHolders: PropTypes.func,
  allExpandbleState: PropTypes.bool,
  displayPriceWithoutTaxes: PropTypes.bool,
  routing: PropTypes.object,
  openSearchboxWin: PropTypes.func
};

export default RoomBox;



// WEBPACK FOOTER //
// ./src/components/RoomBox/RoomBox.js